import { RECEIVED_DATA, REMOVED_DATA, BEGIN_REVISIT_ASSESSMENT, END_REVISIT_ASSESSMENT, TOKEN_HAS_EXPIRED, TOKEN_REFRESHED } from '../actions/statusActionTypes';

const initialState = { errors: {} };

export default function status(state = initialState, action) {
  switch (action.type) {
    case RECEIVED_DATA:
      return {
        ...state,
        [action.key]: true,
      };
    case REMOVED_DATA:
      return {
        ...state,
        [action.key]: false,
      };
    case BEGIN_REVISIT_ASSESSMENT:
      return {
        ...state,
        revisitingAssessment: action.id,
      };
    case END_REVISIT_ASSESSMENT:
      return {
        ...state,
        revisitingAssessment: undefined,
      };
    case TOKEN_HAS_EXPIRED:
      return {
        ...state,
        tokenExpired: true,
      };
    case TOKEN_REFRESHED:
      return {
        ...state,
        tokenExpired: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/statusReducer.js